import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MyBeShowNavbar = ({ children }) => {
  const location = useLocation();
  const [showNavBar, setShowNavBar] = useState(false);

  useEffect(() => {
    if (location.pathname === "d") {
      setShowNavBar(false);
    } else {
      setShowNavBar(true);
    }
  }, [location]);

  return <div>{showNavBar ? children : undefined}</div>;
};

export default MyBeShowNavbar;
